var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGotoIndicator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 34,
    viewBox: "0 0 24 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24.9912L12.3503 25.348C12.1558 25.539 11.8442 25.5389 11.6497 25.348L12 24.9912ZM17.6497 18.7435C17.8468 18.5501 18.1633 18.553 18.3568 18.75C18.5502 18.9471 18.5473 19.2636 18.3503 19.4571L17.6497 18.7435ZM5.64971 19.4571C5.45266 19.2636 5.44975 18.9471 5.64322 18.75C5.83668 18.553 6.15325 18.5501 6.35029 18.7435L5.64971 19.4571ZM11.6497 24.6344L17.6497 18.7435L18.3503 19.4571L12.3503 25.348L11.6497 24.6344ZM11.6497 25.348L5.64971 19.4571L6.35029 18.7435L12.3503 24.6344L11.6497 25.348Z",
    fill: "#4ED5D2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 15.9912L12.3503 16.348C12.1558 16.539 11.8442 16.5389 11.6497 16.348L12 15.9912ZM17.6497 9.74352C17.8468 9.55006 18.1633 9.55296 18.3568 9.75001C18.5502 9.94705 18.5473 10.2636 18.3503 10.4571L17.6497 9.74352ZM5.64971 10.4571C5.45266 10.2636 5.44975 9.94705 5.64322 9.75001C5.83668 9.55296 6.15325 9.55006 6.35029 9.74352L5.64971 10.4571ZM11.6497 15.6344L17.6497 9.74352L18.3503 10.4571L12.3503 16.348L11.6497 15.6344ZM11.6497 16.348L5.64971 10.4571L6.35029 9.74352L12.3503 15.6344L11.6497 16.348Z",
    fill: "#4ED5D2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGotoIndicator);
export default __webpack_public_path__ + "static/media/gotoIndicator.881a085f7d86070793f601d180d0a4ec.svg";
export { ForwardRef as ReactComponent };